import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AlternativeCollegeInfo} from '../../enroll/components/enroll-cabinet/tabs/enroll-entrans-info/model/alternative-college-info';
import {ApplicationSubmission} from '../../enroll/components/model/application-submission';
import {AverageBallCalculation} from '../../enroll/components/model/edu-info/enroll-attestat-average-calculation';

@Injectable()
export class EnrollApplicationService {
  constructor(private _http: HttpClient) {
  }

  canRegister() {
    return this._http.get<boolean>('api/s/enrollApplication/canRegister');
  }

  sendRegistrationApplication(formData, captchaData) {
    return this._http.post<any>(`api/s/enrollApplication/sendRegistrationApplication`, formData,
      {
        headers: {'noContentType': 'true'},
        params: {
          captchaId: captchaData.captchaId,
          captchaCode: captchaData.captchaCode
        }
      });
  }

  saveApplication(formData, enrollId?: any) {
    return this._http.post<any>(`api/enrolls/enrollApplication/saveApplication/${enrollId}`, formData,
      {
        headers: {'noContentType': 'true'}
      });
  }

  sendApplication(formData) {
    return this._http.post<any>(`api/enrolls/enrollApplication/sendApplication`, formData,
      {
        headers: {'noContentType': 'true'}
      });
  }

  cancelSendApplication(formData) {
    return this._http.post<any>(`api/enrolls/enrollApplication/cancelSendApplication`, formData,
      {
        headers: {'noContentType': 'true'}
      });
  }

  cancelConfirmedApplication(formData) {
    return this._http.post<any>(`api/enrolls/enrollApplication/cancelConfirmedApplication`, formData,
      {
        headers: {'noContentType': 'true'}
      });
  }

  getApplication(enrollId?: any): any {
    return this._http.post<any>(`api/enrolls/enrollApplication/getApplication/${enrollId}`,
      {
        headers: {'noContentType': 'true'}
      });
  }

  getEnrollsExamResultList(page) {
    return this._http.post<any>(`api/s/enrolls/enrollApplication/exam/result/list`, page);
  }

  getCenterProfessions(filter: any) {
    return this._http.post<any[]>(`api/s/enrollApplication/centerProfessions/grant`, filter);
  }

  getCenterProfessionsByRegion() {
      return this._http.get<any[]>(`api/s/enrollApplication/centerProfessions/byregion`);
  }

  getCenterSpecializations(filter: any) {
    return this._http.post<any[]>(`api/s/enrollApplication/centerQualifications/grant/filter`, filter);
  }

  getCenterSpecializationsByProfId(filter: any) {
    // const filter = {centerProfessionId: professionId};
    return this._http.post<any[]>(`api/s/enrollApplication/getQualifications`, filter);
  }

  getGSProfessionPlaceCountInfo(filter: any) {
    return this._http.post<AlternativeCollegeInfo[]>(`api/a/gs/profession/placeCount/info`, filter);
  }

  getDicEducatedList() {
    return this._http.get<any[]>('api/s/enrollApplication/educated');
  }

  getDicPaymentFormsList() {
    return this._http.get<any[]>('api/s/enrollApplication/paymentforms');
  }

  getDicDepartmentsList() {
    return this._http.get<any[]>('api/s/enrollApplication/departments');
  }

  getGrantTypes(paymentFormId?: number) {
    if (!paymentFormId) {
      paymentFormId = 0;
    }
    return this._http.get<any>(`api/s/enrollApplication/paymentForm/getGrantTypes/${paymentFormId}`);
  }

  checkHasIIN(enrollId: number, iin: string) {
    return this._http.get<any>('api/enrolls/checkHasIIN/' + enrollId + '/' + iin);
  }

  getGSProfessionsByRegion() {
    return this._http.get<any[]>(`api/a/gs/profession/placeCount/byregion`);
  }

  checkApplicationSubmission(applicationSubmission: ApplicationSubmission) {
    return this._http.post(`api/enrolls/enrollApplication/checkApplicationSubmission`, applicationSubmission, {responseType: 'text'});
  }

  generateLoginPassword(enrollId: number) {
    return this._http.get<any>(`api/enrolls/generateLoginPassword/` + enrollId);
  }

  logAverageBallCalculationByEnrollId(averageBallCalculation: AverageBallCalculation) {
    return this._http.post(`api/enrolls/enrollApplication/attestatAverageBall/${averageBallCalculation.enrollId}`, averageBallCalculation);
  }

  rejectGrant(enrollId: number, statusInfo) {
    return this._http.post<any>(`api/enrolls/enrollApplication/rejectGrant`, statusInfo);
  }

  getGrantCompletionMessage(enrollId: number, lang: string) {
    return this._http.get<any>(`api/enrolls/enrollApplication/grantCompletionMessage/${enrollId}/${lang}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/enroll-application.service.ts